<template>
  <PageHeader :title="title" :subtitle="subtitle" :breadcrumb="breadcrumb">
    <template #actions>
      <slot></slot>
    </template>
  </PageHeader>
</template>

<script setup>
const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  subtitle: String,
  icon: String,
  breadcrumb: {
    type: Boolean,
    default: false,
  },
})
</script>
